<div class="data-upload-container">
  <p style="font-size: 16px"><b>Select Excel Data File to Upload</b></p>
  <form [formGroup]="uploadForm" class="upload-form">
    <input
      #xlsxInput
      hidden="true"
      type="file"
      (change)="xlsxInputChange($event)"
      accept=".xlsx"
    />
    <button
      mat-stroked-button
      (click)="xlsxInput.click()"
      class="upload__button"
    >
      {{
        uploadForm.get("uploadPath")?.value !== ""
          ? uploadForm.get("uploadPath")?.value
          : "Select to browse files"
      }}
    </button>

    <button
      mat-flat-button
      color="primary"
      class="lock"
      type="button"
      [disabled]="!fileData || uploadForm.invalid"
      (click)="uploadFile()"
    >
      UPLOAD FILE
    </button>
  </form>
  <div *ngIf="reviewUploadStatus" class="message-container">
    <p class="error-message reviewUploadStatus">
      Uploaded {{ this.fileData?.name }} excel data file. Review the member
      reconciliation information below. Select ‘Save Upload’ to import records.
    </p>
    <p class="message">
      <b>{{ this.numberOfTotalRecords }}</b> member records are being uploaded
      in total.
    </p>
    <p class="message">
      <b>{{ this.numberOfsameUsernames }}</b> member records data will be
      overwritten.
    </p>
    <p class="message">
      <b>{{ this.numberOfTotalRecords - this.numberOfsameUsernames }}</b> new
      member records being added.
    </p>
    <p class="message">
      List of the new records Usernames (NWMO email address) being added.
    </p>
    <ul>
      <li *ngFor="let item of listOfNewUsernames">
        <p class="message">
          <b>{{ item }}</b>
        </p>
      </li>
    </ul>
    <mat-dialog-actions class="justify-space-between">
      <button
        mat-stroked-button
        color="primary"
        class="blue-outline-button"
        (click)="cancel()"
      >
        CANCEL UPLOAD
      </button>
      <button mat-flat-button color="primary" (click)="saveUpload()">
        SAVE UPLOAD
      </button>
    </mat-dialog-actions>
  </div>
  <div class="successfulUpload error-message" *ngIf="uploadStatus === true">
    Successfully uploaded {{ this.fileData?.name }} excel data file. For more
    information, see table below.
  </div>

  <div *ngIf="uploadStatus === false" class="message-container">
    <p class="failedUpload error-message">
      Failed to upload {{ this.fileData?.name }} excel data file.
    </p>
    <ul>
      <li *ngFor="let error of errors">
        <p class="excel-error">{{ error }}</p>
      </li>
    </ul>
  </div>

  <table
    mat-table
    [dataSource]="allUploadedDataStatus"
    class="mat-elevation-z2 member-settings-table"
    *ngIf="showtable"
  >
    <ng-container matColumnDef="uploadedFileName">
      <th mat-header-cell *matHeaderCellDef class="header-cell">
        Uploaded Filename
      </th>
      <td mat-cell *matCellDef="let element">
        <span>{{ element.uploadedFilename }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="uploadedBy">
      <th mat-header-cell *matHeaderCellDef class="header-cell">Uploaded By</th>
      <td mat-cell *matCellDef="let element">
        {{ element.uploadedBy }}
      </td>
    </ng-container>

    <ng-container matColumnDef="uploadedDate">
      <th mat-header-cell *matHeaderCellDef class="header-cell">
        Uploaded Date
      </th>
      <td mat-cell *matCellDef="let element">
        {{ formatDate(element.uploadedDate) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="uploadedStatus">
      <th mat-header-cell *matHeaderCellDef class="header-cell">
        Uploaded Status
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.uploadedStatus ? "Successful" : "Failed" }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
